/**
 * Fxxl Media
 *
 * Filename: fxxl_media.ts
 *
 * @category  Fahrradxxl
 * @author    Sven Lauer    <s.lauer@fahrrad-xxl.de>
 * @author    Janik Kemnade <j.kemnade@fahrrad-xxl.de>
 * @copyright 2026 Fahrrad-xxl.de
 */



/* 📜 INFORMATION
 * --------------------------------------------------------------------------------------------------------------------
 *
 *
 */






/* 📦️ IMPORTS
 * ----------------------------------------------------------------------------------------------------------------- */
// Imports
import FxxlCore from '@fxxl/core';
import FxxlError from '@fxxl/error';


// Exports
export { FxxlMedia };





/* 📑 ENUMS & TYPES & CONSTANTS
 * ----------------------------------------------------------------------------------------------------------------- */
// Error Messages
enum ERROR_MESSAGE {}

// HTML Classes
enum HTMLCLASS {}


// Selectors
const SELECTOR = {
    VIDEO_AUDIO : 'video, audio',
    IFRAME      : 'iframe',
};


// Proivder Pattern
// Video-Hosts, deren Embeds beim Schließen gestoppt werden;
// funktionale iframes (Payment, Karten) bleiben unangetastet.
const PROVIDER_PATTERN = /(youtube\.com|youtube-nocookie\.com|youtu\.be|player\.vimeo\.com|dailymotion\.com)/i;







/* 💾 INTERFACES
 * ----------------------------------------------------------------------------------------------------------------- */






/* ✒️ CLASS: FxxlMedia
 * ----------------------------------------------------------------------------------------------------------------- */
class FxxlMedia {

    /* 🏷️ VARS
     * ----------------------------------------------------------------------------------------- */




    /** 🐙 HELPER: Stop All Media in Element
     * --------------------------------------------------------------------------------------------
     * Stops video/audio playback inside an element (e.g., YouTube embeds from text blocks/pages)
     * so that it does not continue playing in the background after closing.
     *
     * @param element - The element that needs to be search in for media
     */
    public static stopAllMediaInElement(element: Element | null): void {
        if (element === null) {
            return;
        }

        // PAUSE: HTML5-Video / Audio
        element.querySelectorAll<HTMLMediaElement>(SELECTOR.VIDEO_AUDIO).forEach((mediaElement: HTMLMediaElement): void => {
            mediaElement.pause();
        });

        // RESET: Provider-Embeds src ( Stoppt Video )
        element.querySelectorAll<HTMLIFrameElement>(SELECTOR.IFRAME).forEach((iframeElement: HTMLIFrameElement): void => {
            const currentSource: string = iframeElement.getAttribute('src') ?? '';
            if (PROVIDER_PATTERN.test(currentSource) === false) {
                return;
            }

            // STOP: Playback
            iframeElement.setAttribute('src', currentSource);
        });
    }

}